import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberPdf = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "currentColor",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M3.75.75c0-.207.168-.375.375-.375h10.5c.1 0 .195.04.265.11l6 6c.07.07.11.166.11.265v16.5a.375.375 0 0 1-.375.375h-16.5a.375.375 0 0 1-.375-.375zm.75.375v21.75h15.75V6.905l-5.78-5.78z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M14.625.375c.207 0 .375.168.375.375v5.625h5.625a.375.375 0 0 1 0 .75h-6a.375.375 0 0 1-.375-.375v-6c0-.207.168-.375.375-.375",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M16.368 15h-.672v-3.918h3.15v.6h-2.478v.972h1.506v.6h-1.506zM12.681 15h-1.878v-3.918h1.878c.708 0 1.104.198 1.44.522.348.36.534.864.534 1.434 0 .588-.204 1.122-.576 1.482-.336.3-.69.48-1.398.48m-1.206-.6h1.176c.498 0 .666-.114.9-.306.252-.252.402-.636.402-1.056 0-.408-.132-.774-.378-1.026-.222-.204-.432-.33-.924-.33h-1.176zM6.975 15h-.672v-3.918h2.16c.552 0 .894.156 1.134.414.21.228.312.498.312.786 0 .336-.138.63-.36.846-.234.222-.564.366-1.086.366H6.975zm1.488-3.318H6.975v1.212h1.488c.168 0 .402-.012.594-.192a.563.563 0 0 0 .018-.81c-.18-.192-.42-.21-.612-.21" })
	]
});
export default SvgCyberPdf;
